<template>
  <v-btn
    large
    :to="$_getRouteEdit(role,model.key,$route.params.id,me)"
  >
   {{$t("action.edit")}}
  </v-btn>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components:{
      //
    },
    computed: mapState({
      //
    }),
    props:[
      'me',
      'role',
      'model',
    ],
    data: () => ({
      //
    }),
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>